import {MNullable} from '../../Toolkit/Utils';
import * as Yup from 'yup';
import {Request} from './RequestTypes';

export class Drawing {
    public id: number = 0;
    public parentId: string = '';
    public drawingNum: string = '';
    public drawnBy: number = 0;
    public numOfDrawings: number = 0;
    public paidPerPlan: number = 0;
    public chargePerPlan: number = 0;
    public createdBy: string = '';
    public createdOn: Date = new Date();
    public requestDate?: Date = undefined;
    public turnAround?: number = 0;
    public totalPaid?: number = 0;
    public totalCharged?: number = 0;
    public netProfit?: number = 0;
}

export class DrawingBySummary {
    public label: string = '';
    public drawingsNum: number = 0;
    public paidSum: number = 0;
    public chargedSum: number = 0;
}

export class DrawingRegister {
    public drawing: Drawing = new Drawing();
    public request: Request = new Request();
}

export class DrawingSummary {
    public averageTurnaround: number = 0;
    public monthTotals: number[] = [];
    public totalDrawings: number = 0;
    public drawingMonthlySummaries: DrawingBySummary[] = [];
    public drawingMonthlyTotals: DrawingBySummary = new DrawingBySummary();
    public drawingList: DrawingRegister[] = [];
}

export class CreateDrawingValidator {
    public static readonly parentId = Yup.string().label('Parent Id').required();
    public static readonly drawnBy = Yup.number().label('Drawn By').required();
}

export class UpdateDrawingValidator {
    public static readonly id = Yup.number().label('Id').required();
    public static readonly drawnBy = Yup.number().label('Drawn By').required();
}

export class DrawingReply {
    public drawing: MNullable<Drawing> = null;
}

export class DrawingMultiReply {
    public drawings: Drawing[] = [];
}

export class DrawingSummaryReply {
    public summary: MNullable<DrawingSummary> = null;
}